var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" Sending a "),_c('i',[_vm._v("paymentSuccessfulEvent")]),_vm._v(" request for "+_vm._s(this.$route.params.entityId)+" with a sagepayTransacctionId of "+_vm._s(this.$route.params.sagepayTransactionId)+". ")])])}
var staticRenderFns = []

export { render, staticRenderFns }